// extracted by mini-css-extract-plugin
export default {"fadeIn":"uWvpQe90qYeF5aqM3Jxa"};